import { InputWithLabel } from '@adotel/components'
import { Button, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import SearchIcon from '@material-ui/icons/Search'
import { memo } from 'react'

import PageHeader from '../../components/PageHeader'
import { convertPersianNumbersToEnglishNumbers } from '../../helpers/numbers'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import useStyles from './styles/PaymentTermssHeader.styles'

interface PaymentTermsHeaderProps {
  searchInputValue: string | undefined

  setsearchInputValue: (val: string) => void
}
const PaymentTermsHeader: React.FC<PaymentTermsHeaderProps> = ({
  searchInputValue,
  setsearchInputValue
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div>
      <PageHeader title={getTranslate('Payment Terms List')} />
      <div className={classes.header}>
        <Typography variant="h3" gutterBottom>
          {getTranslate('Payment Terms List')}
        </Typography>
        {/* {tenantPagesRoleManagement
          .find((item) => item.route === '/payment-terms')
          ?.rolesListWithWriteAccess?.includes(getRoleFromStorage()) && ( */}
        <Button
          startIcon={<AddIcon />}
          variant="contained"
          color="primary"
          component={LocalizedLink}
          to="/adopay/payment-term/create">
          {getTranslate(isSmallScreen ? 'Add' : 'New Payment Term')}
        </Button>
        {/* )} */}
      </div>
      <div className={classes.root}>
        <InputWithLabel
          placeholder={getTranslate('Search by name or code')}
          autoComplete="off"
          noHelperText
          fullWidth
          startIcon={<SearchIcon />}
          className={classes.searchInput}
          value={searchInputValue}
          onChange={(event) =>
            setsearchInputValue(
              convertPersianNumbersToEnglishNumbers(event.currentTarget.value)
            )
          }
        />
      </div>
    </div>
  )
}

export default memo(PaymentTermsHeader)
